var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'uk-alert uk-alert-' + _vm.type,attrs:{"uk-alert":""}},[_c('p',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }